import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { PosLogFilterForm, PosLogTable } from 'components/logsPos'
import { Button } from 'components/common'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import { ExportIcon } from 'components/icons'
import { downloadPosLogs } from 'utils/api/logsApi'
import { FILTER_FIELD_POS_LOG } from 'components/logsPos/posLogFilterForm'
import { useQuery } from 'hooks'
import { filterEmptyValues } from 'utils/helpers'

const PosApi = () => {
  const { getQuery } = useQuery()

  const handleExport = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      const logFilter = filterEmptyValues(getQuery(FILTER_FIELD_POS_LOG))

      await downloadPosLogs(
        Object.keys(logFilter).length > 0 ? logFilter : undefined,
      )
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | POS API Logs </title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">POS API Logs</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton filterKey={FILTER_FIELD_POS_LOG} />
          <Button
            type="button"
            buttonText="Export"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ExportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={handleExport}
          />
        </div>
      </div>

      <PosLogFilterForm />
      <PosLogTable />
    </>
  )
}

export default PosApi
